<div class="start-screen">
    <div class="start-screen_content">
      <img class="start-screen_logo" src="./assets/img/logo.png" />
      <div class="title">DABubble</div>
    </div>
  </div>